import React, { useState } from "react";
import { IonButton, IonIcon, IonInput, IonItem, IonLabel } from "@ionic/react";
import { eyeOff, eye } from "ionicons/icons";

export function PasswordField({ label, onChange }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <IonItem className="itemPadding" mode="ios">
      <IonLabel mode="ios" position="floating">
        {label}
      </IonLabel>
      <IonInput
        type={showPassword ? "text" : "password"}
        onIonInput={(e) => {
          onChange(e.target.value);
        }}
        mode="ios"
      ></IonInput>
      <IonButton
        onClick={() => {
          setShowPassword((prev) => !prev);
        }}
        size="default"
        fill="clear"
        slot="end"
        style={{ marginTop: 30 }}
      >
        <IonIcon icon={showPassword ? eyeOff : eye}></IonIcon>
      </IonButton>
    </IonItem>
  );
}
